<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3">A<span class="smallcaps">BBREVIATIONS</span></h1>
<table>
<tbody>
<tr>
<td class="w30"><p class="t-left"><em>BOC</em></p></td>
<td class="w70"><p class="t-left">The Constitution of the Presbyterian Church (USA), <a href="#/010_Part01#pt-1">Part I</a>, <em>Book of Confessions</em>. Louisville: Office of the General Assembly, 2016.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>CD</em></p></td>
<td><p class="t-left">Karl Barth, <em>Church Dogmatics</em>. Edited by G. W. Bromiley, T. F. Torrance, et al. 14 vols. Edinburgh: T&amp;T Clark, 1936–1969.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>CF</em></p></td>
<td><p class="t-left">Friedrich Schleiermacher, <em>The Christian Faith</em>. Edited by H. R. Mackintosh and J. S. Stewart. Philadelphia: Fortress, 1976.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>Dogmatics</em></p></td>
<td><p class="t-left">Emil Brunner, <em>Dogmatics</em>. Vol. 1, <em>The Christian Doctrine of God</em>. Vol. 2, <em>The Christian Doctrine of Creation and Redemption</em>. Vol. 3, <em>The Christian Doctrine of the Church, Faith, and the Consummation</em>. Translated by Olive Wyon and David Cairns. London: Lutterworth, 1952.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>ETP</em></p></td>
<td><p class="t-left">James M. Gustafson, <em>Ethics from a Theocentric Perspective</em>. Vol. 1, <em>Theology and Ethics</em>. Vol. 2, <em>Ethics and Theology</em>. Chicago: University of Chicago Press, 1981, 1984.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>ICR</em></p></td>
<td><p class="t-left">John Calvin, <em>Institutes of the Christian Religion</em>. Edited by John T. McNeill. Translated by Ford Lewis Battles. Louisville: Westminster, 1960.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>IFM</em></p></td>
<td><p class="t-left">Gordon D. Kaufman, <em>In Face of Mystery: A Constructive Theology</em>. Cambridge, MA: Harvard University Press, 1993.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>LW</em></p></td>
<td><p class="t-left"><em>Luther’s Works</em>. Edited by Jaroslav Pelikan et al. American Edition. St. Louis: Concordia, 1958–.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>NDM</em></p></td>
<td><p class="t-left">Reinhold Niebuhr, <em>The Nature and Destiny of Man</em>. Vol. 1, <em>Human Nature</em>. Vol. 2, <em>Human Destiny</em>. Louisville: Westminster John Knox, 1996.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>ST</em></p></td>
<td><p class="t-left">Thomas Aquinas, <em>Summa Theologiae</em>. Blackfriars Edition. New York: McGraw-Hill, 1964–1981.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>WA</em></p></td>
<td><p class="t-left"><em>The Works of Saint Augustine: A Translation for the 21st Century</em>. John E. Rotelle, OSA, director. Hyde Park, NY: New City, 1997–.</p></td>
</tr>
<tr>
<td><p class="t-left"><em>WJE</em></p></td>
<td><p class="t-left"><em>The Works of Jonathan Edwards</em>. General Editors, Perry Miller, John E. Smith, and Harry S. Stout. 26 vols. New Haven: Yale University Press, 1957–2008.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbrevation.vue?54b6165d